import React, { useContext, useState, useEffect } from 'react'
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import AuthContext from '../../context/Auth/AuthContext';
import { validate_changePassword } from './changePassword_validations';
import Notifications, { ERROR_NOTIFICATION, INFO_NOTIFICATION } from '../../helpers/notifications';
import API from '../../services/api';

import './changePassword.css';


const ChangePassword = (props) => {
    const { t } = useTranslation('common');
    const history = useHistory();
    const { is_login, user, update_first_time } = useContext(AuthContext);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');

    useEffect(() => {
        if (props.firstime || user) {
            setEmail(user.email);
        }
    }, [props.firstime, user]);


    const frm_fields_reset = () => {
        if (user || props.firstime) {
            setEmail(user.email);
        } else {
            setEmail('');
        }        
        setPassword('');
        setNewPassword('');
        setRepeatPassword('');
    }


    // ! For some reason original code prevents using change password  once the user was authenticated....
    // ! The code preventing change password to be displayed was removed on 2026.10
    // ! Since the "change password" feature must not be available to the public through the login page.
    // !
    // ! Original code was:
    // !
    // ! if (is_login() && !props.firstime) {
    // !    // * User is logged into the system and tries to go to ChangePassword
    // !    history.push('/');
    // ! }

    const save_new_password = async () => {
        const error = validate_changePassword(email, password, newPassword, repeatPassword, t);        
        if (error.length === 0) {
            const reqData = {
                usr: email,
                cpw: password,
                npw: newPassword
            }
            const res = await API.post("/security/chngpw", reqData);
            const { data } = res
            if (data.code !== 100) {
                Notifications.notify(t(`login.changePasswordError`), ERROR_NOTIFICATION)
            } else {

                if (props.firstime) {
                    update_first_time();
                    history.push('/AuthInstitutions');
                } else {
                    Notifications.notify('Password Updated', INFO_NOTIFICATION);
                    frm_fields_reset();
                }

            }

        } else {
            Notifications.notify(error + "mi error", ERROR_NOTIFICATION)
        }
    }

    return (
        <div className="container-fluid mt-3">
            { props.firstime ?
                <div className="row">
                    <div className="col-md-2"></div>
                    <div className="col-md-8">
                        <p className="title">{t('changePassword.legend')}</p>
                    </div>
                    <div className="col-md-2"></div>
                </div>
                :
                ''
            }
            <div className="row justify-content-center">

                <div className="col-md-8">

                    <div className="row ilo_login_input_container">
                        <div className="col-xs-7 col-sm-7 col-md-3 col-lg-3 col-xl-3 login-label-container">
                            <label className=" ilo_lbl_general labelLogin">{t('changePassword.email')}</label>
                        </div>
                        <div className="col-xs-7 col-sm-7 col-md-5 col-lg-4 col-xl-3 ilo_login_input">
                            <input
                                type="email"
                                disabled={true}
                                className="form-control ilo-input"
                                placeholder={t('changePassword.ph_email')}
                                onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                        save_new_password();
                                    }
                                }}
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value)
                                }}
                            />
                        </div>
                    </div>

                    <div className="row ilo_login_input_container">
                        <div className="col-xs-7 col-sm-7 col-md-3 col-lg-3 col-xl-3 login-label-container">
                            <label className=" ilo_lbl_general labelLogin">{t('changePassword.current_password')}</label>
                        </div>
                        <div className="col-xs-7 col-sm-7 col-md-5 col-lg-4 col-xl-3 ilo_login_input">
                            <input
                                type="password"
                                className="form-control ilo-input"
                                placeholder={t('changePassword.current_password')}
                                onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                        save_new_password();
                                    }
                                }}
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value)
                                }}
                            />
                        </div>
                    </div>

                    <div className="row ilo_login_input_container">
                        <div className="col-xs-7 col-sm-7 col-md-3 col-lg-3 col-xl-3 login-label-container">
                            <label className=" ilo_lbl_general labelLogin">{t('changePassword.new_password')}</label>
                        </div>
                        <div className="col-xs-7 col-sm-7 col-md-5 col-lg-4 col-xl-3 ilo_login_input">
                            <input
                                type="password"
                                className="form-control ilo-input"
                                placeholder={t('changePassword.new_password')}
                                onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                        save_new_password();
                                    }
                                }}
                                value={newPassword}
                                onChange={(e) => {
                                    setNewPassword(e.target.value)
                                }}
                            />
                        </div>
                    </div>

                    <div className="row ilo_login_input_container">
                        <div className="col-xs-7 col-sm-7 col-md-3 col-lg-3 col-xl-3 login-label-container">
                            <label className=" ilo_lbl_general labelLogin">{t('changePassword.repeat_password')}</label>
                        </div>
                        <div className="col-xs-7 col-sm-7 col-md-5 col-lg-4 col-xl-3 ilo_login_input">
                            <input
                                type="password"
                                className="form-control ilo-input"
                                placeholder={t('changePassword.repeat_password')}
                                onKeyPress={event => {
                                    if (event.key === 'Enter') {
                                        save_new_password();
                                    }
                                }}
                                value={repeatPassword}
                                onChange={(e) => {
                                    setRepeatPassword(e.target.value)
                                }}
                            />
                        </div>
                    </div>

                    <div className="row ilo_login_input_container">
                        <div className="col-xs-7 col-sm-7 col-md-3 col-lg-3 col-xl-3 login-label-container">
                            <label className="ilo_lbl_general labelLogin"></label>
                        </div>
                        <div className="col-xs-7 col-sm-7 col-md-5 col-lg-4 col-xl-3 ilo_login_input">
                            <span className="mt-1 pwrules">
                                {t('changePassword.password_rules')}
                            </span>
                        </div>
                    </div>

                    <div className="row ilo_login_input_container change-pw-buttons-container">
                        <div className="col-xs-7 col-sm-7 col-md-8 col-lg-7 col-xl-6 ilo_login_input psw_login_btn">
                            <button onClick={save_new_password} type="submit" className="btn btn-primary ilo-btn fb-btn">{t('changePassword.save_btn')}</button>
                            {!props.firstime &&
                                <Link to="/" type="submit" className="btn btn-primary ilo-btn fb-btn fb-btn-right">{t('changePassword.cancel_btn')}</Link>
                            }
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default ChangePassword;
